import { createContext } from 'react';
import type { FeatureFlags } from './types';

type FeatureFlagsContextType = {
	featureFlags: FeatureFlags;
	featureFlagsOverrides: Partial<FeatureFlags>;
	ldFeatureFlags: FeatureFlags;
	setOverride: (flag: keyof FeatureFlags, value: boolean) => void;
	clearOverride: (flag: keyof FeatureFlags) => void;
	isLoading: boolean;
};

export const FeatureFlagsContext = createContext<FeatureFlagsContextType>({
	featureFlags: {} as FeatureFlags,
	featureFlagsOverrides: {},
	ldFeatureFlags: {} as FeatureFlags,
	setOverride: () => {},
	clearOverride: () => {},
	isLoading: true,
});
